<template>
  <div class="zoox-component zoox-week-selection">
    <template v-for="(day, index) in weekDays">
      <v-tooltip :key="index" top>
        <template #activator="{on}">
          <div
            ref="week-day"
            :class="getClass(day)"
            @click="handleClick(day.value)"
            v-on="on"
          >
            {{ day.text[0].toUpperCase() }}
          </div>
        </template>
        {{ day.text }}
      </v-tooltip>
    </template>
  </div>
</template>

<script>
/**
 * @displayName Week Selection
 */
export default {
  name: 'ZWeekSelection',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /**
     * Array indicando os valores selecionados
     *
     * @modelName value
     */
    value: {type: Array, required: true, default: () => []},
  },
  computed: {
    weekDays() {
      return [
        {text: this.$t('sunday'), value: 0},
        {text: this.$t('monday'), value: 1},
        {text: this.$t('tuesday'), value: 2},
        {text: this.$t('wednesday'), value: 3},
        {text: this.$t('thursday'), value: 4},
        {text: this.$t('friday'), value: 5},
        {text: this.$t('saturday'), value: 6},
      ]
    },
  },
  methods: {
    handleClick(dayValue) {
      const index = this.value.findIndex((val) => val === dayValue)
      // Se não existir o dia, adiciona
      if (index === -1) {
        /**
         * Evento emitido ao selecionar ou deselecionar um dia
         *
         * @property {Array} value - Array com os valores selecionados
         */
        this.$emit('change', [...this.value, dayValue])
      } else {
        // Se existir o dia, remove

        /**
         * Evento emitido ao selecionar ou deselecionar um dia
         *
         *  @property {Array} value - Array com os valores selecionados
         */
        this.$emit(
          'change',
          this.value.filter((val) => val !== dayValue)
        )
      }
    },
    getClass(day) {
      return `day-button ${
        this.value.includes(day.value) ? 'selected' : 'unselected'
      }`
    },
  },
  i18n: {
    messages: {
      en: {
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
      },
      pt: {
        sunday: 'Domingo',
        monday: 'Segunda',
        tuesday: 'Terça',
        wednesday: 'Quarta',
        thursday: 'Quinta',
        friday: 'Sexta',
        saturday: 'Sábado',
      },
      es: {
        sunday: 'Domingo',
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
      },
      fr: {
        sunday: 'Dimanche',
        monday: 'Lundi',
        tuesday: 'Mardi',
        wednesday: 'Mercredi',
        thursday: 'Jeudi',
        friday: 'Vendredi',
        saturday: 'Samedi',
      },
      tr: {
        sunday: 'Pazar',
        monday: 'Pazartesi',
        tuesday: 'Salı',
        wednesday: 'Çarşamba',
        thursday: 'Perşembe',
        friday: 'Cuma',
        saturday: 'Cumartesi',
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-week-selection {
  display: flex;
  .day-button {
    display: flex;
    align-content: center;
    justify-content: center;
    border-radius: 50%;
    background-color: var(--background);
    height: 25px;
    width: 25px;
    padding: 0.3em 0.8em;
    color: var(--black);
    font-weight: 500;
    font-size: 0.75em;
    cursor: pointer;
    &:not(:first-child) {
      margin-left: 0.25em;
    }
    &.selected {
      background-color: var(--primary);
      color: var(--white);
    }
  }
}
</style>
